export default __webpack_public_path__ + "static/media/icon-upload.3ab99773.svg";